
<template>
  <div>
    <query-form class="form" @query="query" @reset="resetQuery"></query-form>
    <activity-table class="themeTable" ref="mainTable"></activity-table>
  </div>
</template>
<script>
import queryForm from "./email-query.vue";
import activityTable from "./email-table.vue";
export default {
  components: {
    queryForm,
    activityTable
  },
  methods: {
    query(data) {
      data.isReset = true;
      this.$nextTick(() => {
        this.$refs.mainTable.getTableData(data);
      });
    },
    resetQuery() {
      this.$nextTick(() => {
        this.$refs.mainTable.resetForm();
        this.$refs.mainTable.getTableData({ isReset: true });
      });
    }
  },
  created() {
    this.query({});
  }
};
</script>
<style lang="less" scoped>
.form,
.themeTable {
  margin-top: 12px;
  margin-left: 20px;
  width: 95%;
  margin-left: 30px;
}
.themeTable {
  margin-left: 30px;
}
</style>
